import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./navigtion/Header";
import Footer from "./navigtion/Footer";
import Home from "./pages/Home";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import UserDataDeletion from "./pages/UserDataDeletion";
import "./css/App.css";

const App = () => {
  return (
    <Router>
      <div className="app-container">
        <Header />

        <main className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Terms" element={<Terms />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
            {/* <Route path="/privacy.html" element={<PrivacyPolicy />} /> */}
            <Route path="/user-data-deletion" element={<UserDataDeletion />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
};

export default App;
